import React, { useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import profile from "assets/images/profile-img.png"
import logo from "assets/images/favicon.png"
import { useHistory } from "react-router-dom"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { Link } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap"

const Register = () => {
  const navigate = useHistory()
  const [errors, setErrors] = useState({})
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // State for toggling password visibility
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [showSecurityPin, setShowSecurityPin] = useState(false)

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    countryCode: "",
    password: "",
    confirmPassword: "",
    securityPin: "",
    userType: "Supplier",
    supplierType: "",
  })

  const validateForm = () => {
    const newErrors = {}
    const pinRegex = /^\d{4}$/

    if (!form.firstName.trim()) {
      newErrors.firstName = "First name is required"
    } else if (form.firstName.length < 1) {
      newErrors.firstName = "First name must be at least 1 characters"
    }

    if (!form.lastName.trim()) {
      newErrors.lastName = "Last name is required"
    } else if (form.lastName.length < 1) {
      newErrors.lastName = "Last name must be at least 1 characters"
    }

    if (!form.phone) {
      newErrors.phone = "Phone number is required"
    } else if (form.phone.length < 5) {
      newErrors.phone = "Phone number is too short"
    }

    if (!form.securityPin) {
      newErrors.securityPin = "Security PIN is required"
    } else if (!pinRegex.test(form.securityPin)) {
      newErrors.securityPin = "Security PIN must be 4 digits"
    }

    if (!form.password) {
      newErrors.password = "Password is required"
    } else if (form.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters"
    }

    if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match"
    }

    if (!agreedToTerms) {
      newErrors.terms = "You must agree to the terms and conditions"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleChange = e => {
    const { name, value } = e.target

    if (name === "securityPin") {
      if (value.length <= 4 && /^\d*$/.test(value)) {
        setForm(prev => ({ ...prev, [name]: value }))
      }
      return
    }

    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) {
      return
    }
    setIsSubmitting(true)
    const formData = new FormData()
    formData.append("supplierType", form.supplierType)
    formData.append("firstName", form.firstName)
    formData.append("lastName", form.lastName)
    formData.append("countryCode", form.countryCode)
    formData.append("phone", form.phone)
    formData.append("email", form.email)
    formData.append("password", form.password)
    formData.append("confirmPassword", form.confirmPassword)
    formData.append("securityPin", form.securityPin)
    formData.append("userType", form.userType)

    try {
      const response = await axios.post(URLS.Register, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      if (response.status === 200) {
        toast.success(response.data.message || "Registration successful!")
        sessionStorage.setItem("phone", form.phone)
        localStorage.setItem(
          "tost",
          "OTP has been sent successfully to specified phone number..!"
        )
        navigate.push("/verifyotp")
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "An error occurred during registration"
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="#" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={8} xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Join Us Today !</h5>
                        <p>Create Your Account in a few steps.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="#">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form onSubmit={handleSubmit} autoComplete="off">
                      <Row>
                        <Col md="12">
                          <div className="mb-3">
                            <Label>
                              Supplier Type{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="select"
                              name="supplierType"
                              value={form.supplierType}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Type</option>
                              <option value="Company">Company</option>
                              <option value="Retailer">Retailer</option>
                            </Input>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              First Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              id="firstName"
                              name="firstName"
                              className={`form-control ${
                                errors.firstName && "is-invalid"
                              }`}
                              value={form.firstName}
                              onChange={handleChange}
                              placeholder="Enter First Name"
                              invalid={!!errors.firstName}
                            />
                            <FormFeedback>{errors.firstName}</FormFeedback>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Last Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              id="lastName"
                              name="lastName"
                              className={`form-control ${
                                errors.lastName && "is-invalid"
                              }`}
                              value={form.lastName}
                              onChange={handleChange}
                              placeholder="Enter Last Name"
                              invalid={!!errors.lastName}
                            />
                            <FormFeedback>{errors.lastName}</FormFeedback>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                              type="email"
                              id="email"
                              name="email"
                              className="form-control"
                              value={form.email}
                              onChange={handleChange}
                              placeholder="Enter Email (optional)"
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Phone <span className="text-danger">*</span>
                            </Label>
                            <PhoneInput
                              country={"in"}
                              value={`${form.countryCode}${form.phone}`}
                              onChange={(value, country) => {
                                setForm({
                                  ...form,
                                  countryCode: country.dialCode,
                                  phone: value.replace(country.dialCode, ""),
                                })
                                if (errors.phone) {
                                  setErrors({ ...errors, phone: null })
                                }
                              }}
                              inputClass={`form-control ${
                                errors.phone && "is-invalid"
                              }`}
                              dropdownClass="country-dropdown"
                              placeholder="Enter Phone Number"
                              enableSearch
                            />
                            {errors.phone && (
                              <div className="invalid-feedback d-block">
                                {errors.phone}
                              </div>
                            )}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Security PIN
                              <span className="text-danger">*</span>
                            </Label>
                            <InputGroup>
                              <Input
                                type={showSecurityPin ? "text" : "password"}
                                id="securityPin"
                                name="securityPin"
                                className={`form-control ${
                                  errors.securityPin && "is-invalid"
                                }`}
                                value={form.securityPin}
                                onChange={handleChange}
                                placeholder="Enter 4-digit PIN"
                                invalid={!!errors.securityPin}
                                maxLength="4"
                              />
                              <InputGroupText
                                className="cursor-pointer"
                                onClick={() =>
                                  setShowSecurityPin(!showSecurityPin)
                                }
                              >
                                <i
                                  className={`fas ${
                                    showSecurityPin ? "fa-eye" : "fa-eye-slash"
                                  }`}
                                />
                              </InputGroupText>
                              <FormFeedback>{errors.securityPin}</FormFeedback>
                            </InputGroup>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <InputGroup>
                              <Input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                className={`form-control ${
                                  errors.password && "is-invalid"
                                }`}
                                value={form.password}
                                onChange={handleChange}
                                placeholder="Enter Password (min 6 characters)"
                                invalid={!!errors.password}
                              />
                              <InputGroupText
                                className="cursor-pointer"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i
                                  className={`fas ${
                                    showPassword ? "fa-eye" : "fa-eye-slash"
                                  }`}
                                />
                              </InputGroupText>
                              <FormFeedback>{errors.password}</FormFeedback>
                            </InputGroup>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Confirm Password
                              <span className="text-danger">*</span>
                            </Label>
                            <InputGroup>
                              <Input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                name="confirmPassword"
                                className={`form-control ${
                                  errors.confirmPassword && "is-invalid"
                                }`}
                                value={form.confirmPassword}
                                onChange={handleChange}
                                placeholder="Confirm Password"
                                invalid={!!errors.confirmPassword}
                              />
                              <InputGroupText
                                className="cursor-pointer"
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                              >
                                <i
                                  className={`fas ${
                                    showConfirmPassword
                                      ? "fa-eye"
                                      : "fa-eye-slash"
                                  }`}
                                />
                              </InputGroupText>
                              <FormFeedback>
                                {errors.confirmPassword}
                              </FormFeedback>
                            </InputGroup>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <div className="mt-4 text-center">
                            <div className="form-check">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                id="termsCheck"
                                value={agreedToTerms}
                                onChange={e =>
                                  setAgreedToTerms(e.target.checked)
                                }
                                invalid={!!errors.terms}
                              />
                              <Label
                                className="form-check-label"
                                for="termsCheck"
                              >
                                I agree to the Bizzmate Supplier
                                <Link to="/Terms" className="text-primary">
                                  Terms & Conditions
                                </Link>
                                and
                                <Link to="/Privacy" className="text-primary">
                                  Privacy Policy
                                </Link>
                              </Label>
                              {errors.terms && (
                                <div className="invalid-feedback d-block">
                                  {errors.terms}
                                </div>
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mt-4">
                            <button
                              className="btn btn-primary btn-block w-100"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Processing...
                                </>
                              ) : (
                                "Register"
                              )}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} Bizzmate Supplier. Crafted with
                  <i className="mdi mdi-heart text-danger" /> by Bizzmate
                  Supplier
                </p>
              </div>
            </Col>
          </Row>
          <ToastContainer />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Register
